import { render } from "./ViewportControls.vue?vue&type=template&id=dfdf713a&scoped=true"
import script from "./ViewportControls.vue?vue&type=script&lang=js"
export * from "./ViewportControls.vue?vue&type=script&lang=js"

import "./ViewportControls.vue?vue&type=style&index=0&id=dfdf713a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dfdf713a"

export default script